import { configureStore } from '@reduxjs/toolkit';
import authReducer from './pages/reducer/slices/authSlice';
import cartReducer from './pages/reducer/slices/cartSlice';
import productReducer from './pages/reducer/slices/productSlice';
import partnerCartReducer from './pages/reducer/slices/partnerCartSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    cart: cartReducer,
    partnerCart: partnerCartReducer,
  }
});

export default store;